export const ORDER_SUMMARY_COLORS = ['#3038F3', '#46D767', '#FF8D0E', '#FF8042'];
